import { themeColor } from "./_helpers";

export const fgTokens = {
  title: themeColor({
    base: "{colors.neutral.900}",
    _themeBlack: "{colors.white}",
    _themeWhite: "{colors.neutral.900}",
  }),
  body: themeColor({
    base: "{colors.neutral.700}",
    _themeBlack: "{colors.neutral.200}",
    _themeWhite: "{colors.neutral.700}",
  }),
  muted: themeColor({
    base: "{colors.neutral.400}",
    _themeBlack: "{colors.neutral.100}",
    _themeWhite: "{colors.neutral.500}",
  }),
  active: themeColor({
    base: "{colors.primary.600}",
    _themeBlack: "{colors.primary.200}",
    _themeWhite: "{colors.primary.600}",
  }),
  inactive: themeColor({
    base: "{colors.neutral.500}",
    _themeBlack: "{colors.neutral.400}",
    _themeWhite: "{colors.neutral.500}",
  }),
  strong: themeColor({
    base: "{colors.neutral.800}",
    _themeBlack: "{colors.white}",
    _themeWhite: "{colors.neutral.800}",
  }),
  inverse: themeColor({
    base: "{colors.white}",
    _themeBlack: "{colors.white}",
    _themeWhite: "{colors.white}",
  }),
  link: themeColor({
    base: "{colors.indigoCustom.600}",
    _themeBlack: "{colors.indigoCustom.400}",
    _themeWhite: "{colors.indigoCustom.600}",
  }),
  brandStrong: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.primary.200}",
    _themeWhite: "{colors.primary.500}",
  }),
  error: themeColor({
    base: "{colors.red.600}",
    _themeBlack: "{colors.red.400}",
    _themeWhite: "{colors.red.600}",
  }),
  success: themeColor({
    base: "{colors.success.700}",
    _themeBlack: "{colors.success.400}",
    _themeWhite: "{colors.success.700}",
  }),
  warning: themeColor({
    base: "{colors.sunset-orange.700}",
    _themeBlack: "{colors.sunset-orange.400}",
    _themeWhite: "{colors.sunset-orange.700}",
  }),
};
